function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from 'react';
import PropTypes from 'prop-types';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import APButton from '../APButton';
import APIcon from '../APIcon';
import './APInlineButton.css';
var baseClass = 'ap-inline-btn';
var APInlineButton = function APInlineButton(props) {
  var icon = props.icon,
    text = props.text,
    customClass = props.customClass,
    iconModifier = props.iconModifier,
    otherProps = _objectWithoutProperties(props, ['icon', 'text', 'customClass', 'iconModifier']);
  var bemClasses = getBEMClasses([baseClass, customClass]);
  return React.createElement(APButton, Object.assign({
    baseClass: baseClass,
    customClass: customClass
  }, otherProps), React.createElement(APIcon, {
    name: icon,
    classModifiers: iconModifier,
    customClass: bemClasses('image')
  }), React.createElement('span', {
    className: bemClasses('text')
  }, text));
};
APInlineButton.propTypes = {
  icon: PropTypes.string.isRequired,
  iconModifier: PropTypes.string,
  text: PropTypes.string.isRequired,
  customClass: PropTypes.string
};
APInlineButton.defaultProps = {
  customClass: 'custom-inline-btn'
};
export default APInlineButton;